import type { ApiCursorBody, ApiResponse } from '@/types/api-response.types'
import type { Lecture, LectureDetail, LectureOrder, LectureRequest, LectureSummary } from '@/types/lecture.types'
import api from '../axios'

export const lectureService = {
  async getLectures({ free, recommended, courseIdx, level, mentorIdx, onlyBookmarked, onlyPurchased, searchKeyword, programIdx, cursor, size = 20, ascending = false }: LectureRequest): Promise<ApiCursorBody<Lecture>> {
    const response: ApiResponse<ApiCursorBody<Lecture>> = await api.get('/v1/lecture', {
      params: {
        free,
        recommended,
        courseIdx,
        level: level?.toUpperCase(),
        mentorIdx,
        onlyBookmarked,
        onlyPurchased,
        searchKeyword,
        programIdx,
        cursor,
        size,
        ascending,
      },
    })
    return response.body
  },

  async getLectureDetail(idx: number): Promise<LectureDetail> {
    const response: ApiResponse<LectureDetail> = await api.get(`/v1/lecture/${idx}`)
    return response.body
  },

  async getLectureSummary(): Promise<LectureSummary> {
    const response: ApiResponse<LectureSummary> = await api.get(`/v1/lecture/main`)
    return response.body
  },

  async updateStatistic(idx: number, watchSeconds: number): Promise<void> {
    const response: ApiResponse<void> = await api.post(`/v1/lecture/${idx}/statistics`, {
      watchSeconds: watchSeconds,
    })
    return response.body
  },

  async createOrder(idx: number, subscription: boolean): Promise<LectureOrder> {
    const response: ApiResponse<LectureOrder> = await api.post(`/v1/lecture/${idx}/order`, {
      purchaseType: subscription ? 'SUBSCRIPTION' : 'PERMANENT',
    })
    return response.body
  },

  async toggleBookmark(idx: number): Promise<boolean> {
    const response: ApiResponse<boolean> = await api.post(`/v1/lecture/${idx}/bookmark`)
    return response.body
  },

  async requestApprovalPayment(receiptId: string): Promise<void> {
    const response: ApiResponse<void> = await api.post(`/v1/lecture/payment/${receiptId}`)
    return response.body
  },
}
